<template>
  <div class="yxl-more-new" v-if="info">
    <div class="text" ref="text" :class="textClass">
      <div class="btn" @click="setShowAll" v-if="isMore">
        <span v-if="!showall && isMore && isShowMore">...<i>全部</i></span>
        <span v-else-if="showall && this.hiddenBtn">收起</span>
      </div>
      <div class="content" ref="content" v-html="info"></div>
    </div>
    <div
      :style="{ '-webkit-line-clamp': lineClamp }"
      class="text hide"
      ref="hide"
    >
      <p class="content" v-html="info"></p>
    </div>
  </div>
</template>
<script>
import { ResizeObserver } from '@juggle/resize-observer'
export default {
  name: 'yxlmoreNew',
  props: {
    info: {
      type: String,
      default: ''
    },
    lineClamp: {
      type: Number,
      default: 3
    },
    isShowMore: {
      type: Boolean,
      default: true
    },
    hiddenBtn: {
      type: Boolean,
      default: true
    },
    isClickShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showall: false,
      isMore: false
    }
  },
  computed: {
    textStyleObject() {
      return {
        'max-height': this.showall ? 'none' : `${1.5 * this.lineClamp}em`
      }
    },
    textClass() {
      let cls = this.showall ? 'showall' : ''
      return cls
    }
  },
  watch: {
    info() {
      this.showall = false
      this.setMore()
    }
  },
  mounted() {
    this.setMore()
  },
  methods: {
    setShowAll() {
      if (!this.isClickShow) return
      this.showall = !this.showall
      this.$emit('setShowAllCallback', this.showall)
    },
    setMore() {
      const { content, hide, text } = this.$refs
      if (content && hide && text) {
        const ro = new ResizeObserver((entries, observer) => {
          /**
           * text为所有内容高度，hide为设置行数后的高度，如果text比hide高，则需要控制省略
           * 同时把hide高度赋给text
           */
          this.$nextTick(() => {
            const hideHeight = hide.offsetHeight
            this.isMore = content.offsetHeight > hideHeight
            this.isMore && (this.$refs.text.style.maxHeight = `${hideHeight}px`)
          })
          observer.disconnect() // Stop observing
        })
        ro.observe(hide)
      }
    }
  }
}
</script>
<style lang="scss">
.yxl-more-new {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  line-height: 1.5;

  i {
    font-style: normal;
  }

  .text {
    width: 100%;
    position: relative;
    overflow: hidden;
    line-height: 1.5;
    text-align: justify;
    text-overflow: ellipsis;
    word-break: break-all;
    transition: 0.3s max-height;
    &.hide {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -99999;
      overflow: visible;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
  .text::before {
    float: right;
    height: calc(100% - 1em);
    content: '';
  }
  .btn {
    position: relative;
    float: right;
    clear: both;
    margin-left: 2px;
    line-height: 0.7;
    padding: 0 8px;
    color: #206ef7;
    border-radius: 4px;
    z-index: 10;
  }

  .text.showall {
    max-height: none !important;
  }
}
</style>
